import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {driversColumns} from './columns/_columns'
import {Driver} from '../core/_models'
import {DriversListLoading} from '../components/loading/DriversListLoading'
import {DriversListPagination} from '../components/pagination/DriversListPagination'
import { KTCardBody } from '../../../../../_metronic/helpers'
// import {KTDriverdBody} from '../../../../../../_metronic/helpers'

const DriversTable = () => {
  const drivers = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => drivers, [drivers])
  const columns = useMemo(() => driversColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_drivers'
          className='table align-middle table-row-dashed  fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start bg-light-secondary fw-bolder fs-6 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Driver>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className=' fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Driver>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <DriversListPagination />
      {isLoading && <DriversListLoading />}
    </KTCardBody>
  )
}

export {DriversTable}
